module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.value, '')))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d738c78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Currency.vue
// module id = 531
// module chunks = 1